import { serviceSettingsService } from '@/modules/global-settings/onboarder/services/service-settings.service';
import { make } from 'vuex-pathify';
// Create a new serviceSettingsService instance
const service = new serviceSettingsService();
// Service Settings Module State
export const state = {
  services: []
};
// Service Settings Module Mutations
export const mutations = {
  ...make.mutations(state)
};
// Service Settings Module Getters
export const getters = {
  ...make.getters(state),
  activeServices(state) {
    return state.services.filter((s) => s.status == true);
  }
};
// Service Settings Module Actions
export const actions = {
  /**
   * Fetch all services
   * @param {Object} context - Vuex context object
   * @returns {Number} status - HTTP status code
   * @private This will update the state
   */
  async fetchServices({ commit }) {
    const { status, data } = await service.fetchServices();
    commit('SET_SERVICES', data);
    return status;
  },
  /**
   * Update a service
   * @param {Object} context - Vuex context object
   * @param {Object} payload - Payload object
   * @param {String} payload.id - Service ID
   * @param {Object} payload.updates - Service updates
   * @returns {Number} status - HTTP status code
   * @private This will re-fetch the services
   */
  async updateService({ dispatch }, { id, updates }) {
    const { status } = await service.updateService(id, updates);
    dispatch('fetchServices');
    return status;
  },

  /**
   * Create a new service
   * @param {Object} context - Vuex context object
   * @param {Object} newService - New service object
   * @returns {Number} status - HTTP status code
   * @private This will re-fetch the services
   */
  async createService({ dispatch }, newService) {
    const { status } = await service.createService(newService);
    dispatch('fetchServices');
    return status;
  }
};
